import React from 'react';
export default {
  'cart': {
    'change-currency': 'मुद्रा बदलें',
    'and-then': 'और फिर',
    'plus-tax': ' + कर',
    'for': 'के लिए',
    'email.reminder': ({ days }: { days: number }) => <>बिलिंग शुरू होने से {days} दिन पहले आपको ईमेल रिमाइंडर मिलेगा</>,'edit': {
      'label': 'बदलाव करें',
      'submit': 'लागू करें'
    },
    'empty': 'आपने अभी तक अपने ऑर्डर में कुछ भी नहीं जोड़ा है.',
    'free': 'नि:शुल्क',
    'promo-code': {
      'add': 'गिफ्ट कार्ड या प्रोमो कोड जोड़ें',
      'error': {
        'invalid-for-subscription': 'कूपन कोड इस ऑर्डर के लिए मान्य नहीं है।'
      },
      'label': 'गिफ्ट कार्ड या प्रोमो कोड',
      'submit': 'लागू करें'
    },
    'subtotal-line': {
      'tax-label': 'अनुमानित कर',
      'subtotal': 'उप कुल',
      'tax': 'टैक्स',
      'gift-card': 'उपहार पत्र'
    },
    'starting-price': 'अंकित मूल्य',
    'title': 'आदेश सारांश',
    'setup-fee': 'सेटअप शुल्क',
    'free-trial': 'मुफ्त आज़माइश',
    'total-line': {
      'label': 'कुल'
    },
    'order-total-line': {
      'label': 'ऑर्डर टोटल'
    }
  },
  'address': {
    'country': 'देश',
    'address2': 'अपार्टमेंट, सुइट, आदि.',
    'tax-identifier': 'कर पहचानकर्ता',
    'tax-identifier-type': 'कर पहचानकर्ता प्रकार',
    'first-name': 'पहला नाम',
    'last-name': 'अंतिम नाम',
    'company-name': 'कंपनी का नाम',
    'address1': 'पता',
    'city': 'शहर',
    'state': 'प्रांत',
    'postal-code': 'जिप/पिन',
    'phone-number': 'फ़ोन नंबर',
    'vat-number': 'VAT नंबर/कर ID'
  },
  'payment-method': {
    'credit-card': {
      'label': 'कार्ड का विवरण',
      'expiry': 'महीना/साल',
      'name': 'क्रेडिट कार्ड',
      'number': 'क्रेडिट कार्ड संख्या ',
      'cvv': 'CVV',
      'brand': {
        'visa': 'Visa',
        'master': 'MasterCard',
        'cartes_bancaires': 'Cartes Bancaires'
      }
    },
    'ach': {
      'name': 'बैंक खाता',
      'routing-number': 'राउटिंग नम्बर',
      'account-number': 'खाता संख्या',
      'account-number-confirmation': 'खाता संख्या पुष्टि करें',
      'account-type': {
        'label': 'खाते का प्रकार',
        'checking': 'खाते की जांच',
        'savings': 'बचत खाता'
      },
      'name-on-account': 'खाते पर मौजूद नाम'
    },
    'amazon': {
      'name': 'Amazon'
    },
    'apple-pay': {
      'name': 'Apple Pay'
    },
    'boleto': {
      'name': 'Boleto'
    },
    'bacs': {
      'name': 'Bacs',
      'sort-code': 'Sort कोड'
    },
    'becs': {
      'name': 'BECS',
      'bsb-code': 'BSB कोड'
    },
    'google-pay': {
      'name': 'Google Pay'
    },
    'ideal': {
      'name': 'Ideal'
    },
    'paypal': {
      'name': 'PayPal'
    },
    'qiwi_wallet': {
      'name': 'Qiwi Wallet'
    },
    'sepa': {
      'name': 'SEPA',
      'iban': 'IBAN'
    },
    'sofort': {
      'name': 'Sofort'
    },
    'venmo': {
      'name': 'Venmo'
    }
  },
  'billing-address': 'बिल भेजने का पता',
  'billing-address-same-as-shipping': 'शिपिंग पते के समान ही',
  'submit': 'अब भुगतान करें',
  'payment-method-selected': ({ paymentMethod }: { paymentMethod: string }) => <>{paymentMethod} चुना गया</>,
  'express-checkout': 'एक्सप्रेस चेकआउट',
  'change-payment-method': 'भुगतान विधि को बदलें',
  'day': 'दिन',
  'days': 'दिनों',
  'week': 'हफ़्ता',
  'weeks': 'हफ़्ते',
  'month': 'महीना',
  'months': 'महीने',
  'year': 'वर्ष',
  'years': 'वर्षों',
  'confirmation': {
    'title': 'ऑर्डर करने के लिए धन्यवाद',
    'order-num': ({ number }: { number: number }) => <>ऑर्डर #{number}</>,
    'fulfilled-on': ({ date }: { date: string }) => <>{date} को पूरा हुआ</>,
    'email-notice': 'ऑर्डर प्लेस हो जाने पर आपको एक ईमेल कन्फर्मेशन प्राप्त होगा.',
    'payment': 'भुगतान',
    'return-to': ({ name }: { name: string }) => <>{name} पर वापिस जाएँ</>,
    'credit-applied': 'खाते में जमा'
  },
  'back': 'वापस',
  'contact-info': 'संपर्क करने संबंधी जानकारी',
  'email-address': 'ईमेल',
  'payment-info': 'बिलिंग जानकारी',
  'shipping-address': 'शिपिंग पता',
  'legal': {
    'accept': 'मैं स्वीकार करता हूँ',
    'privacy-policy': 'गोपनीयता नीति',
    'terms-of-service': 'सेवा की शर्तें'
  },
  'recurring': {
    'consent': `मैं ऊपर बताए गए शुल्कों का भुगतान, जो बिलिंग की अवधि के अनुसार हैं, बार-बार करने के लिए सहमत हूँ,
                जब तक कि वर्तमान बिलिंग पीरियड खत्म होने से पहले सब्सक्रिप्शन रद्द न कर दिया जाए.`,
    'cancel': 'अपना सब्सक्रिप्शन रद्द करने के लिए, अपने अकाउंट मैनेजमेंट पेज पर जाएँ.'
  },
  'pluralize': {
    'days': ({ count }: { count: number }) => count === 1 ? 'दिन' : 'दिनों',
    'weeks': ({ count }: { count: number }) => count === 1 ? 'हफ़्ता' : 'हफ़्ते',
    'months': ({ count }: { count: number }) => count === 1 ? 'महीना' : 'महीने',
    'years': ({ count }: { count: number }) => count === 1 ? 'वर्ष' : 'वर्षों'
  },
  'subscription': {
    'details': {
      'addons': {
        'flat.charge': ({ amount, addOnName }: { amount: string; addOnName: string }) => <>{addOnName} के लिए आपसे {amount}/यूनिट की दर से शुल्क लिया जाएगा</>,
        'no-flat.charge': ({ amount, units, unitsLabel, addOnName }: { amount: string; units: number; unitsLabel: string; addOnName: string }) => <>{addOnName} के {units} {unitsLabel} के लिए आपसे {amount} का शुल्क लिया जाएगा</>
      },
      'billing.starting': ({ startDate, amount, intervalLengthLabel, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; taxable?: boolean }) => <>{startDate} से आपसे {amount}/{intervalLengthLabel}{taxable ? ' + कर' : ''} का बिल भेजा जाएगा</>,
      'billing.starting.setupfee': ({ startDate, amount, intervalLengthLabel, setupFee, taxable = true }: { startDate: string; amount: string; intervalLengthLabel: string; setupFee: string; taxable?: boolean }) => <>{startDate} से आपसे {amount}/{intervalLengthLabel}{taxable ? ' + कर' : ''} का बिल भेजा जाएगा, साथ ही {setupFee} का एकमुश्त शुल्क भी</>,
      'cancellation.reminder': 'बिलिंग शुरू होने से {days} दिन पहले आपको ईमेल रिमाइंडर मिलेगा।',
      'trial.start': ({ trialLength, trialInterval }: { trialLength: number; trialInterval: string }) => <>आज से आपका {trialLength} {trialInterval} का निःशुल्क ट्रायल शुरू हो गया है।</>,
      'trial.ends': ({ trialEndsAt }: { trialEndsAt: string }) => <>शुल्क से बचने के लिए, आपको {trialEndsAt} से पहले रद्द करना होगा।</>,
      'email.reminder': ({ days }: { days: number }) => <>बिलिंग शुरू होने से {days} दिन पहले आपको ईमेल रिमाइंडर मिलेगा</>,
      'no-renewal': ({ billingEndsAt }: { billingEndsAt: string }) => <>आपका सब्सक्रिप्शन {billingEndsAt} को समाप्त हो जाएगा और अपने आप नवीनीकृत नहीं होगा।</>,
      'ramp.after': ({ afterChargeTime, newChargeAmount }: { afterChargeTime: string; newChargeAmount: string }) => <>{afterChargeTime} के बाद, आपसे {newChargeAmount} + कर का शुल्क लिया जाएगा</>,
      'renewal': ({ totalCyclesLengthLabel }: { totalCyclesLengthLabel: string }) => <>आपका सब्सक्रिप्शन हर {totalCyclesLengthLabel} अपने आप नवीनीकृत होगा और जब तक आप रद्द नहीं करते तब तक जारी रहेगा।</>,
      'title': 'सब्सक्रिप्शन विवरण',
    },
    'agreement.button': 'सहमत हैं और जारी रखें',
    'agreement.text': '"सहमत हैं और जारी रखें" पर क्लिक करके, आप पुष्टि करते हैं कि आप इन सब्सक्रिप्शन शर्तों को समझते और स्वीकार करते हैं। चेकआउट पूरा होने तक कोई शुल्क लागू नहीं होगा।',
    'changeOrCancel': 'अपना सब्सक्रिप्शन बदलने या रद्द करने के लिए ',
    'access-account': 'अपने खाते तक पहुंचें',
    'contact-support': 'सहायता से संपर्क करें',
  },
  'currency-display': ({ currency }: { currency: string }) => <>{(currency || '').toUpperCase()}</>,
  'support': {
    'array': {
      'wordsConnector': ', ',
      'twoWordsConnector': ' और ',
      'lastWordConnector': ', और '
    }
  },
  'powered-by': ({ recurly }: { recurly: string }) => <>सदस्यता बिलिंग {recurly} द्वारा संचालित है</>,
  'errors': {},
  'subscribe': 'सदस्यता लें'
};
